module.exports = {"id":"212616","name":"Rodrigo Javier De Paul","rating":"74","photo":"./data/images/photos/4/212616.png","club":{"name":"Udinese","logo":"./data/images/clubs/Udinese.png"},"positions":["AD","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RodrigoJavierDePaul0.json
// module id = 3669
// module chunks = 0